import { Outlet, RouteObject } from "react-router-dom";
import {
  SHIFT_LIST_PAGE_PATH,
  ShiftListPage,
} from "@/modules/timesheet/pages/shift-list-page";
import { HrModuleOr404 } from "@/shared/modules/ui/hr-module-or-404";
import {
  TIMESHEET_PATH,
  TimesheetPage,
} from "@/modules/timesheet/pages/timesheet";

export const timesheetRoutes: RouteObject[] = [
  {
    element: (
      <HrModuleOr404>
        <Outlet />
      </HrModuleOr404>
    ),
    children: [
      {
        path: SHIFT_LIST_PAGE_PATH,
        element: <ShiftListPage />,
      },
      {
        path: TIMESHEET_PATH,
        element: <TimesheetPage />,
      },
    ],
  },
];
